export default (window as any)?.config || {};
